import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 3l-8 4.5l8 4.5","key":"svg-0"}],["path",{"d":"M8 12l8 4.5l-8 4.5","key":"svg-1"}]]

const IconBrandStocktwits = createReactComponent('outline', 'brand-stocktwits', 'BrandStocktwits', __iconNode);

export default IconBrandStocktwits;